import React, { useEffect, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Box, Chip, IconButton } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import TagMenuSVG from "../icons/TagMenuSVG"
import RemoveTagSVG from "../icons/RemoveTagSVG"
import AddTagSVG from "../icons/AddTagSVG"
import PlusSVG from "../icons/PlusSVG"
import clsx from "clsx"
import CreateTag from "./CreateTag"
import { tagButtonClicked } from "../../actions/customTagsActions"
import { updateFileTag } from "../../actions/documentsActions"
import { CONTEXT_TYPE, LIST_VIEW } from "../../utils"
import TagMenuPoper from "./TagMenuPoper"
import TagChip from "./TagChip"

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		width: "314px",
		height: "56px",
		alignItems: "center",
		gap: 4,
		flexShrink: 0,
	},
	moreIcon: {
		display: "flex",
		padding: "2px 4px",
		alignItems: "center",
		borderRadius: "3px",
		background: "rgba(52, 118, 228, 0.04)",
		"& .MuiIconButton-root": {
			padding: 0,
		},
		"& .MuiIconButton-label": {
			...theme.typography.body1,
			fontSize: theme.typography.fontSize,
		},
	},
}))

function MultiTag(props) {
	const classes = useStyles()
	const { setMultiTagDialogOpen, setMultiTagDialogData, selectedSearch, setCurrFileId } = props?.tagState
	const [showApplyTag, setShowApplyTag] = useState(false)
	const { id } = useSelector((state) => state?.review?.review)

	const dispatch = useDispatch()

	const showAllTags = () => {
		setMultiTagDialogData(props?.fileData?.tags || [])
		setMultiTagDialogOpen(true)
		setCurrFileId(props?.fileData?.id)
	}

	const handleApplyTagClick = (e) => {
		setShowApplyTag(true)
		dispatch(tagButtonClicked())
	}

	const getCurrentContext = () => {
		if (id) {
			return {
				name: CONTEXT_TYPE?.REVIEW,
				id: id,
			}
		} else if (selectedSearch?.id) {
			return {
				name: CONTEXT_TYPE?.SEARCH,
				id: selectedSearch?.id,
			}
		} else {
			return {
				name: CONTEXT_TYPE?.FILE,
				id: 0,
			}
		}
	}

	useEffect(() => {
		setShowApplyTag(false)
	}, [])

	const getTagCounter = () => {
		let tagCounter
		if (props?.fileData?.tags?.length > 2) {
			tagCounter = props?.fileData?.tags?.length - 2
		} else {
			tagCounter = 0
		}
		return tagCounter
	}

	return (
		<Box className={classes.root}>
			{showApplyTag ? (
				<CreateTag
					fileId={props?.fileData?.id}
					setShowApplyTag={setShowApplyTag}
					currentContext={getCurrentContext}
					tagData={props?.fileData?.tags}
				/>
			) : (
				<>
					<TagChip
						fileId={props?.fileData?.id}
						tagData={props?.fileData?.tags}
						getCurrContext={getCurrentContext}
						view={LIST_VIEW}
					/>
					{getTagCounter() > 0 && (
						<Box component="span" className={classes.moreIcon}>
							<IconButton onClick={showAllTags} size="small">
								<PlusSVG />
								{getTagCounter()}
							</IconButton>
						</Box>
					)}
					<IconButton onClick={handleApplyTagClick} size="small">
						<AddTagSVG />
					</IconButton>
				</>
			)}
		</Box>
	)
}

export default MultiTag
